package com.essntl.features.currency.ui.addcurrency

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.currency.ui.addcurrency.components.CurrencyItem
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AddCurrencyScreen(
    state: AddCurrencyState,
    onEvent: (AddCurrencyEvent) -> Unit,
) {
    var searchText by remember { mutableStateOf("") }

    val filteredCurrencies = remember(
        searchText,
        state.getAllCurrencies.data.orEmpty(),
    ) {
        state.getAllCurrencies.data.orEmpty()
            .filter {
                it.name.contains(
                    searchText,
                    ignoreCase = true,
                ) ||
                    it.code.contains(
                        searchText,
                        ignoreCase = true,
                    )
            }
    }

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxSize()
            .padding(24.dp),
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .align(Alignment.TopCenter),
        ) {
            EsInput(
                value = searchText,
                onValueChange = { searchText = it },
                placeholder = "Search",
                prefix = {
                    EsLargeIcon(
                        res = EsIcons.Search,
                    )
                },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(modifier = Modifier.height(2.spacing))

            if (state.getAllCurrencies.isLoading)
                EsSpinner()
            else if (state.getAllCurrencies.isFailure)
                Text(
                    text = "Something goes wrong!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            else if (state.getAllCurrencies.data
                    .orEmpty()
                    .isEmpty()
            )
                Text(
                    text = "No currencies found!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )
            else
                LazyColumn(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(EsConstants.ListColumnHeaderHeight),
                    contentPadding = PaddingValues(vertical = EsConstants.SectionVerticalPadding),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    items(filteredCurrencies) { currency ->
                        CurrencyItem(
                            currency = currency,
                            enabled = state.configurationCurrency.value?.allowed?.contains(currency.code) == false,
                            checked = state.selectedCurrenciesCode.contains(currency.code),
                            onCheckedChange = {
                                onEvent(AddCurrencyEvent.SelectUnselectCurrency(currency.code))
                            },
                        )
                    }
                }
        }

        EsLargePrimaryButton(
            onClick = { onEvent(AddCurrencyEvent.AddCurrencies) },
            text = "Add selection",
            loading = state.addCurrency.isLoading,
            enabled = state.selectedCurrenciesCode.isNotEmpty(),
            modifier = Modifier
                .fillMaxWidth()
                .align(Alignment.BottomCenter),
        )
    }
}